import axios from "axios";
import UnGraduateTemplate from "componets/templates/underGraduate/unGraduateTemplate";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseURL } from "utilities/variables";
import "./unGraduate.scss";
const Programs = () => {
  const navigate = useNavigate();
  const [programasOfertados, setprogramasOfertados] = useState(undefined);
  const [data, setData] = useState([programasOfertados]);
  const [currentURL, setCurrentURL] = useState(useParams()["id"]);
  useEffect(() => {
    if (programasOfertados != undefined) {
      var result = programasOfertados.find(
        (element) => element.id == currentURL
      );
      if (result === undefined) {
        navigate(`/programas`);
      }
    }
  }, [currentURL, programasOfertados]);
  useEffect(() => {
    let auxData = [programasOfertados];
    setData(auxData);
  }, [programasOfertados]);
  useEffect(() => {
    axios
      .get(
        baseURL +
          "/api/programas-ofertados?populate=imagenPrincipal.imagen&populate=nivelFormacion&populate=tablas.filas&populate=perfil&populate=objetivos.descripcion"
      )
      .then((response) => {
        let auxData = response.data.data;
        let auxEasyData = [];
        auxData.map((value) => {
          auxEasyData.push({
            id: value.id,
            title: value.attributes.titulo,
            description: value.attributes.descripcion,
            imgURL: `${baseURL}${value.attributes.imagenPrincipal.imagen.data.attributes.url}`,
            alt: value.attributes.imagenPrincipal.imagen.data.attributes
              .alternativeText,
            code:
              "Codigo SIA " +
              value.attributes.codigoSia +
              " - Código SNIES " +
              value.attributes.codigoSNIES,
            type: value.attributes.nivelFormacion.tipo,
            codeSIA: value.attributes.codigoSia,
            codeSNIES: value.attributes.codigoSNIES,
            date: value.attributes.fechaCreacion,
            degree: value.attributes.tituloQueOtorga,
            modality: value.attributes.modalidad,
            schedule: value.attributes.jornada,
            duration: value.attributes.duracionEstimada,
            faculty: value.attributes.facultad,
            site: value.attributes.sede,
            curricularArea: value.attributes.areaCurricularPregrado,
            totalCredits: value.attributes.creditosTotales,
            formationName: value.attributes.nivelFormacion.nombre,
            formationType: value.attributes.nivelFormacion.tipo,
            profile: value.attributes.perfil,
            objetives: value.attributes.objetivos,
            tables: value.attributes.tablas,
          });
        });
        setprogramasOfertados(auxEasyData);
      });
  }, []);
  return (
    <div className="Programs__main-container">
      {data[0] !== undefined && data[0].length > 0 && (
        <UnGraduateTemplate dataRow={data[0]} currentOption={currentURL} />
      )}
    </div>
  );
};

export default Programs;
